export default __webpack_public_path__ + "static/stephanie-06488c2830ac3b1a46ca992f8b95fc33.webp";